import { render, staticRenderFns } from "./DashboardEquipes.vue?vue&type=template&id=dd4edc36"
import script from "./DashboardEquipes.vue?vue&type=script&lang=js"
export * from "./DashboardEquipes.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipes.vue?vue&type=style&index=0&id=dd4edc36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports